import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];
  const operation = properties.operation || 'now';

  // Validate based on operation
  switch (operation) {
    case 'parse':
      if (!properties.input?.trim()) {
        errors.push({ key: 'input', message: 'Input string is required for parse operation' });
      }
      break;

    case 'add':
    case 'subtract':
      if (properties.value === undefined || properties.value === null || properties.value === '') {
        errors.push({ key: 'value', message: 'Value is required for add/subtract operations' });
      }
      if (!properties.unit) {
        errors.push({ key: 'unit', message: 'Unit is required for add/subtract operations' });
      }
      break;

    case 'diff':
      if (!properties.start?.trim()) {
        errors.push({ key: 'start', message: 'Start date is required for diff operation' });
      }
      if (!properties.end?.trim()) {
        errors.push({ key: 'end', message: 'End date is required for diff operation' });
      }
      if (!properties.unit) {
        errors.push({ key: 'unit', message: 'Unit is required for diff operation' });
      }
      break;
  }

  return {
    valid: errors.length === 0,
    errors
  };
}
